import InvoiceOrdersGrid from './InvoiceOrdersGrid';

export default InvoiceOrdersGrid;
